<template>
	<div class="py-3" :class="{'border-bottom-dashed':index+1 != product.variant_list.length}">
    <div class="row slim-grid-row">
      <div class="col-6 col-sm-7 align-self-center">
        <p class="mb-1 body-2-2-1" style="color: #00000073">{{data.name}}</p>
        <p class="mb-0 body-1-4 color-black">{{formatCurrency(base_price)}}</p>
      </div>
      <div class="col-6 col-sm-5 text-center align-self-center">
        <div class="w-100" v-if="data.availability > 0">
          <div class="plus-min-set mb-2">
          	<img v-if="store.is_cart" src="../../../../assets/img/icon/decrement-active.png" class="d-inline-block mr-1 border-green" width="28" style="padding: 7px;border-radius: 5px;" @click="changeQtyProduct('minus')">
            <img v-else src="../../../../assets/img/icon/decrement.png" class="d-inline-block mr-1" width="28" style="padding: 7px;border-radius: 5px;border:1px solid #70707046;">

            <div class="d-inline-block border-none border-bottom-green text-center body-2-4 counter" style="width:45px;">
              {{store.data.qty}}
            </div>

            <img v-if="store.data.qty < data.availability" src="../../../../assets/img/icon/increment.png" class="d-inline-block border-green ml-1" width="28" style="padding: 7px;border-radius: 5px;" @click="changeQtyProduct('plus')">
            <img v-else src="../../../../assets/img/icon/increment-disabled.png" class="d-inline-block mr-1" width="28" style="padding: 7px;border-radius: 5px;border:1px solid #70707046;">
          </div>
          <p v-if="store.data.qty >= data.availability" class="mb-0 body-3-1 text-danger">Only {{data.availability}} stock available</p>
        </div>
        <button v-else class="btn w-100 body-2-4 rounded-10 py-2 text-center text-green"style="background-color: #EFEFEF" >{{$t('merchant.out-of-stock')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
  import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'
  import {mapGetters,mapMutations} from "vuex";
  export default{
    props:['data','product','index','merchant'],
    computed:{
      store(){
        let data = {
          is_cart: false,
          data: {
            qty: 0
          }
        } 
        let record = this.getConciergeOrder().experience.cart.findIndex(x=>x.product.data.id == this.product.id)

        if(record != -1){
          let variant_record = this.getConciergeOrder().experience.cart[record].variant.findIndex(x=>x.data.id == this.data.id)
          if(variant_record != -1){
            data.is_cart = true
            data.data = this.getConciergeOrder().experience.cart[record].variant[variant_record]
          }
        }

        return data
      },
      base_price(){
        return calculateFinalPriceConcierge(this.data.price)
      }
    },
    methods:{
      ...mapGetters(['getMerchant','getConciergeOrder']),
      ...mapMutations(['setConciergeOrderExperience','removeConciergeOrderExperience']),
      formatCurrency(data){
        return formatCurrency(data)
      },
      changeQtyProduct(type){
        let params = {
          merchant: this.merchant,
          product: this.product,
          variant: this.data,
          qty: this.store.is_cart ? this.store.data.qty : 0
        }
        if(this.store.data.qty == 1 && type == 'minus'){
          this.removeConciergeOrderExperience(params)
        }else{
          if(type == 'minus'){
            params.qty--
          }else{
            params.qty++
          }
          this.setConciergeOrderExperience(params)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/productExperienceVariant.vue